import { CustomRewardCurrency } from "@joonapp/web-shared"
import { useEffect } from "react"

import { ScreenTimeControlsModalStep } from "../../../constants"
import { useCustomRewardsQuery } from "../../../networking/rewards/queries"
import { ScreenTimeControlsModalType } from "../../../types/rewards"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"
import { localStorageItems } from "../../../util/storage"
import { useScreenTimeControlsModalStore } from "../redeem/ScreenTimeControlsModal"

export const useShowInitialScreenTimeControlsModal = () => {
  const {
    isOpen: isOpenScreenTimeControlsModal,
    onOpen: onOpenScreenTimeControlsModal,
  } = useScreenTimeControlsModalStore()
  const { data: rewards } = useCustomRewardsQuery()
  const hasScreenTimeReward = rewards?.some(
    (reward) => reward.currency === CustomRewardCurrency.MINUTE
  )

  return useEffect(() => {
    const hasSeenScreenTimeControlsModal = localStorage.getItem(
      localStorageItems.hasSeenScreenTimeControlsModal
    )
    if (
      !hasSeenScreenTimeControlsModal &&
      !isOpenScreenTimeControlsModal &&
      !hasScreenTimeReward
    ) {
      trackAnalyticEvent(ANALYTIC_EVENTS.VIEW_SCREENTIME_FTUX)
      onOpenScreenTimeControlsModal({
        step: ScreenTimeControlsModalStep.ANNOUNCEMENT,
        modalType: ScreenTimeControlsModalType.FTUX,
      })
    }
  }, []) // eslint-disable-line
}
